// extracted by mini-css-extract-plugin
export default {"formLabel":"Label_formLabel__ztBPH","formLabel__disabled":"Label_formLabel__disabled__av4vL"};